<h1>{{document.propertiesObj.DocumentTitle}}
  <span *ngIf="!!document?.propertiesObj?.ContractDeletedDate" class="deleted">- Deleted</span></h1>

<div class="alert alert-warning" *ngIf="saveFailed">Edit failed,
  please contact Support</div>

<div class="tabs__control">
  <ul class="inline-list">
    <li>
      <button matTooltip="Save" *ngIf="!saving" mat-icon-button (click)="save()">
        <mat-icon><img src="assets/images/icon-save.svg" /></mat-icon>
      </button>
    </li>
    <li>
      <button matTooltip="Close" mat-icon-button
        [routerLink]="['/',(documentID$ | async).objectStore,'DocumentView',(documentID$ | async).id]"
        queryParamsHandling="merge">
        <mat-icon><img src="assets/images/icon-close.svg" /></mat-icon>
      </button>
    </li>
  </ul>
</div>

<mat-tab-group class="tabs__section" (selectedTabChange)="tabClicked($event)" #tabs>
  <mat-tab label="Document Properties">
    <mat-card class=" mat-card-sub">
      <!-- <div class="alert alert-warning" *ngIf="!properties?.isValid && properies.">Properties not valid</div> -->
      <document-properties-edit #properties [(ngModel)]="document" [objectStore]="(documentID$ | async)?.objectStore" [document]="(document$ | async)"
        [masterDataRequired]="(folder$ | async)?.propertiesObj.FolderMasterDataRequired" [folder]="folder$ | async">
      </document-properties-edit>
    </mat-card>
  </mat-tab>

  <!-- <mat-tab label="Comments">
    <mat-card class=" mat-card-sub">
      <app-comments-view [(ngModel)]="document.annotations" [addButton]="true"></app-comments-view>
    </mat-card>
  </mat-tab> -->
  <mat-tab label="Linked Documents">
    <mat-card class=" mat-card-sub">
      <div class="alert alert-warning" *ngIf="linkedDocumentRequired() && !(document?.linkedDocuments?.length>0) ">At
        least one
        linked document is required</div>
      <app-linked-documents-view [documentID]="document?.id" [addButton]="true" name="linkedDocuments"
        [(ngModel)]="document.linkedDocuments" [folderID]="(folder$ | async)?.id"
        [objectStore]="(documentID$ | async)?.objectStore"
        (ngModelChange)="document.propertiesObj.FinalizeLinkedDocuments = document?.linkedDocuments?.length > 0">
      </app-linked-documents-view>
    </mat-card>
  </mat-tab>
  <!-- <mat-tab label="Event Notifications">
    <mat-card class=" mat-card-sub">
      <app-event-notification-view [(ngModel)]="document.alerts" [addButton]="true"
        [objectStore]="(documentID$ | async)?.objectStore" [document]="document"
        (ngModelChange)="document.propertiesObj.FinalizeEventNotifications = document?.alerts?.length > 0">
      </app-event-notification-view>
    </mat-card>
  </mat-tab> -->
  <mat-tab label="Delete" *ngIf="(userRoles$ | async)?.superUser">
    <mat-card class=" mat-card-sub">
      <div class="form-container">
        <section class="custom-check-box-group">
          <!-- Tired of fighting with this so just a hack -->
          <mat-checkbox *ngIf="!!document?.propertiesObj?.ContractDeletedDate" class="custom-check-box"
            name="ContractDeletedDate" [checked]="true" (click)="deletedToggle()">Mark
            Contract as Deleted
          </mat-checkbox>
          <mat-checkbox *ngIf="!document?.propertiesObj?.ContractDeletedDate" class="custom-check-box"
            name="ContractDeletedDate" [checked]="false" (click)="deletedToggle()">Mark
            Contract as Deleted
          </mat-checkbox>
        </section>
      </div>
      <div class="form-container" *ngIf="!!document.propertiesObj.ContractDeletedDate">

        <mat-form-field appearance="outline" required matTooltip="The reason the contract has been deleted">
          <mat-label>Delete Reason</mat-label>
          <mat-select #ContractDeleteReason="ngModel" name="ContractDeleteReason"
            [(ngModel)]="document.propertiesObj.ContractDeleteReason" required>
            <mat-option value="" disabled selected>Please select</mat-option>
            <mat-option
              *ngFor="let docClass of null | asyncChoiceListChoices:(documentID$ | async)?.objectStore:'ContractDeletedReason' | async"
              [value]="docClass.id">
              {{docClass.value}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="ContractDeleteReason?.errors?.required">
            Field is required
          </mat-error>
        </mat-form-field>
      </div>
    </mat-card>
  </mat-tab>
  <!-- *ngIf="(userRoles$ | async)?.superUser" REMOVED feedback from Day 3 training -->
  <mat-tab label="Security">
    <mat-card class="mat-card-sub">
      <app-permissions name="acl" [(ngModel)]="document.acl" [editMode]="true"></app-permissions>
    </mat-card>
  </mat-tab>
</mat-tab-group>

<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>
